import React from "react";
import {
  BookIcon,
  BookOpenIcon,
  CogIcon,
  CreditCardIcon,
  PlatformApplicationsIcon,
  ColumnIcon,
  HomeIcon,
  UsersConfigurationIcon,
  MemberIcon,
  DownloadDocumentIcon,
  BillingIcon,
} from "../../styles/icons";
import { Accordion } from "@chakra-ui/react";
import {
  DesktopMenuItem,
  DesktopSubMenuItem,
  MobileMenuItem,
  MobileSubMenuItem,
} from "./HomeMenu";

export const AdminMenu = ({ isDesktop }: { isDesktop: boolean }) => {
  const MenuItem = isDesktop ? DesktopMenuItem : MobileMenuItem;
  const SubMenuItem = isDesktop ? DesktopSubMenuItem : MobileSubMenuItem;

  return (
    <Accordion allowToggle width="100%">
      <MenuItem target="/" icon={<HomeIcon boxSize="20px" />} title="Home" />

      <MenuItem
        target="/admin/businesses"
        icon={<CogIcon boxSize="20px" />}
        title="Businesses"
      />
      <MenuItem
        target="/admin/users"
        icon={<UsersConfigurationIcon boxSize="20px" />}
        title="Users"
      />

      <MenuItem
        target="admin/members"
        icon={<MemberIcon boxSize="20px" />}
        title="Members"
      />

      <MenuItem
        target="/admin/cherrypay-cards"
        icon={<CreditCardIcon boxSize="20px" />}
        title="CherryPay Cards"
      />

      <MenuItem
        target="/admin/applications"
        icon={<PlatformApplicationsIcon boxSize="20px" />}
        title="Applications"
      />

      <MenuItem
        target="/admin/reports"
        icon={<BookIcon boxSize="20px" />}
        title="Reports"
      >
        <SubMenuItem
          icon={<ColumnIcon />}
          target="/admin/reports/dmc-status"
          title="DMC Status"
        />

        <SubMenuItem
          icon={<DownloadDocumentIcon />}
          target="/admin/reports/status"
          title="Status"
        />

        <SubMenuItem
          icon={<BookOpenIcon />}
          target="/admin/reports/standard"
          title="Standard Reports"
        />

        <SubMenuItem
          icon={<ColumnIcon />}
          target="/admin/reports/comparative"
          title="Comparative Reports"
        />

        <SubMenuItem
          icon={<BillingIcon />}
          target="/admin/reports/twilio-billing"
          title="Twilio Billing"
        />
      </MenuItem>
    </Accordion>
  );
};
